import { getCourseById } from 'redux/services/course';

/* @ngInject */
export default function NvNotificationsPopover(
  $document,
  $state,
  $stateParams,
  $timeout,
  $uibModal,
  CurrentCourseManager,
  CurrentPermissionsManager,
  CurrentUserManager,
  DashboardManager,
  RailsRoutes,
  config,
  nvUtil,
) {
  const ARROW_WIDTH = 10;
  const RIGHT_TOP_PADDING = 5;

  return {
    restrict: 'A',
    scope: {
      templateUrl: '=',
      popoverId: '@?',
      currentInstitution: '=?',
      gridController: '=?',
      popoverPlacement: '@',
      popoverOpenCallback: '&?',
      popoverCloseCallback: '&?',
      arrowSelector: '@?',
      popoverLabel: '@?',
      tooltipPlacement: '@?',
    },
    transclude: true,
    templateUrl: 'shared/templates/nv-notifications-popover.html',
    controller: function ctrl($scope, $element, $attrs) {
'ngInject';
      const vm = Object.assign(this, {
        $state,
        $stateParams,
        CurrentCourseManager,
        CurrentPermissionsManager,
        CurrentUserManager,
        DashboardManager,
        RailsRoutes,
        config,
        currentUser: CurrentUserManager.user,
        showPopover: false,

        togglePopover,
        popoverContentVisible,
        closePopover,
        popoverClick,
        popoverStyles,
        popoverArrowStyles,
        showLanguageModal,
        currentCourseCatalogId,
        adjustPopoverHeight,
        shouldShowMentoringProgramProfileOption,
        shouldShowCourseProfileOption,
        handleProfileClick,
      });

      /** Popover Control * */
      function togglePopover(event) {
        if (vm.showPopover) {
          closePopover();
        } else {
          /**
           * Manually trigger the 'mouseleave' event to hide the tooltip immediately on showing popover.
           * This is required because the tooltip does not disappear instantly when the popover is shown
           */
          if (event?.target) {
            angular.element(event.target).trigger('mouseleave');
          }

          openPopover();
        }
      }

      function popoverContentVisible(inview, inviewInfo) {
        if (inview) {
          const popoverContent = $element.find('#popover-content');

          let lastkey = null;
          const setLastKey = ($event) => {
            lastkey = $event.key;
          };

          const closeVisiblePopover = ($event) => {
            // Close the popover when the user tabs beyond its content and loses focus on it
            if (lastkey === 'Tab'
                && $event.relatedTarget
                && !popoverContent[0].contains($event.relatedTarget)) {
              popoverContent.off('keydown', setLastKey);
              popoverContent.off('focusout', closeVisiblePopover);

              closePopover();
            }
          };

          popoverContent.on('keydown', setLastKey);
          popoverContent.on('focusout', closeVisiblePopover);
        }
      }

      function openPopover() {
        $timeout(() => {
          vm.showPopover = true;
          $scope.$emit('setPopoverId', vm.popoverId);
          $document.on('click keypress', closePopover);
          adjustPopoverHeight();
          vm.popoverOpenCallback?.();
        });
      }

      function closePopover(event) {
        // The 'branding-header' id is coming from branding-header component to know when a click is being programmaticaly dispatched by that component and prevent the popover to close.
        if ((event?.type === 'keypress' && event?.which !== 13) || event?.target?.id === 'branding-header') {
          return;
        }
        $element.find('.popover').hide();
        vm.showPopover = false;
        $timeout(() => {
          $scope.$emit('setPopoverId', '');
          $document.off('click keypress', closePopover);
          vm.popoverCloseCallback?.();
        });
      }

      function popoverClick(event) {
        event.stopPropagation();
      }

      /** Popover Positioning * */
      function popoverTop() {
        if (vm.popoverPlacement === 'bottom') {
          return $element.position().top + $element.outerHeight();
        }
        if (vm.popoverPlacement === 'right' || vm.popoverPlacement === 'left') {
          return $element.position().top - RIGHT_TOP_PADDING;
        }
        return null;
      }

      function popoverStyles() {
        if (nvUtil.isRtl()) {
          return {
            top: popoverTop(),
            right: popoverLeft(),
          };
        }
        return {
          top: popoverTop(),
          left: popoverLeft(),
        };
      }

      function popoverArrowStyles() {
        if (nvUtil.isRtl()) {
          return {
            top: popoverArrowTop(),
            right: popoverArrowLeft(),
          };
        }
        return {
          top: popoverArrowTop(),
          left: popoverArrowLeft(),
        };
      }

      function popoverLeft() {
        if (vm.popoverPlacement === 'bottom') {
          return '10px';
        }
        if (vm.popoverPlacement === 'right' || vm.popoverPlacement === 'left') {
          return $element.position().left + $element.outerWidth();
        }
        return null;
      }

      function popoverArrowTop() {
        if (vm.popoverPlacement === 'right' || vm.popoverPlacement === 'left') {
          return getArrowTarget().outerHeight() / 2 + RIGHT_TOP_PADDING;
        }
        return null;
      }

      function popoverArrowLeft() {
        if (vm.popoverPlacement === 'bottom') {
          if (nvUtil.isRtl()) {
            // Arrow doesn't work as expected with positioning from right.
            // LTR `left: 0` andRTL `right: 0` positions different.
            // So need to add a 13px correction
            return $(window).width() - $element.offset().left - $element.outerWidth() / 2 - ARROW_WIDTH - 13;
          }
          // arrow is 20px wide
          return $element.position().left + $element.outerWidth() / 2 - ARROW_WIDTH;
        }
        return null;
      }

      /** Helper * */
      function getArrowTarget() {
        const arrowElem = $element.find(`${vm.arrowSelector}:visible`);

        if (arrowElem.length) {
          return arrowElem;
        }
        return $element;
      }

      /** Setup * */
      function closeListener() {
        if (vm.showPopover) {
          $timeout(() => {
            closePopover();
          });
        }
      }

      function showLanguageModal() {
        const context = { isLearner: true };
        const LanguageModal = $uibModal.open({
          templateUrl: 'shared/templates/language-modal.html',
          controller: 'LanguageModalCtrl as vm',
          resolve: {
            currentUser: vm.currentUser,
            context,
          },
        });
      }

      function currentCourseCatalogId() {
        if (vm.CurrentUserManager.currentUserCourse) {
          return getCourseById(vm.CurrentUserManager.currentUserCourse.courseId)?.catalogId;
        }
        return null;
      }

      function adjustPopoverHeight() {
        $timeout(() => {
          const viewportHeight = window.innerHeight;
          const smallScreenHeight = 500;
          // Only apply height adjustment if the screen height is less than 500px
          if (viewportHeight < smallScreenHeight) {
            const popoverContent = $element.find('#popover-content');
            if (popoverContent.length) {
              const popoverRect = popoverContent[0].getBoundingClientRect();
              const padding = 10; // 10px padding for safety
              const availableHeight = viewportHeight - popoverRect.top - padding;

              popoverContent.css({
                'max-height': `${availableHeight}px`,
                'overflow-y': 'auto',
              });
            }
          } else {
            // Reset the popover height for larger screens
            const popoverContent = $element.find('#popover-content');
            if (popoverContent.length) {
              popoverContent.css({
                'max-height': '',
                'overflow-y': '',
              });
            }
          }
        });
      }

      function shouldShowMentoringProgramProfileOption() {
        return vm.$stateParams.programId;
      }

      function handleProfileClick() {
        closePopover();
        if (vm.CurrentUserManager?.getProgramsAsAdminCount() > 0) {
          $state.go(
            'org-level-profile-modal',
            { userId: vm.currentUser.id },
            { reload: true },
          );
        } else {
          $state.go('.', { showProfile: true, authenticationView: undefined });
        }
      }

      function shouldShowCourseProfileOption() {
        return (
          vm.$stateParams.catalogId
          && vm.CurrentUserManager.currentUserCourse
          && !vm.CurrentUserManager?.course?.isJourney
        );
      }

      $scope.$on('lhsScroll', closeListener);
      $scope.$on('closeLhsPopover', closeListener);

      /** Cleanup * */
      $scope.$on('$destroy', () => {
        $document.off('click', closePopover);
      });
    },
    controllerAs: 'popoverVm',
    bindToController: true,
  };
}
